export interface ApiQueryError {
    error: string;
    errorArgs: object | null;
    hasContactLink: boolean;
}

export interface ApiEndpointState<Data> {
    loading: boolean;
    queryError: ApiQueryError | null;
    data: null | Data;
}

export type StateKeysWhichAreApiEndpointState<State> = {
    [K in keyof State]-?: State[K] extends ApiEndpointState<unknown> ? K : never;
}[keyof State];

export type StateValueForeApiEndpointKey<State, K extends keyof State> =
    State[K] extends ApiEndpointState<infer U> ? U : never;

export function createEmptyState<Data>(): ApiEndpointState<Data> {
    return {
        loading: false,
        queryError: null,
        data: null,
    };
}
